<template>
  <modal name="skip" :adaptive="true" height="auto">
    <div style="padding: 30px;">
      <div class="warning-block">
        <img src="@/assets/warning.svg" />
      </div>
      <div>
        <h2>Are you sure you want to skip verifying your {{ skipType }}?</h2>
        <p>
          Skipping this step may impact your eligibility to rent this unit.
        </p>
      </div>
      <div class="actions">
        <a class="back" @click="close()">Go Back</a>
        <a class="skip" @click="skip()">Skip</a>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: "SkipModal",
  props: {
    skipType: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$modal.hide("skip");
    },
    skip() {
      this.$modal.hide("skip");
      this.$emit("skip");
    }
  }
};
</script>
<style lang="scss" scoped>
.warning-block {
  img {
    height: 72px;
    width: 75px;
    display: block;
    margin: auto;
  }
}
h2 {
  font-weight: 300;
  font-size: 30px;
  line-height: 34px;
  text-align: center;
  color: #2c2b2b;
}
p {
  font-size: 20px;
  line-height: 34px;
  font-weight: 300;
  text-align: center;
  color: #545454;
}
.back {
  display: block;
  width: 150px;
  padding: 10px 0;
  border: 2px solid #3ec19d;
  background: #3ec19d;
  border-radius: 2px;
  text-decoration: none;
  font-size: 18px;
  color: #fff;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  font-size: 18px;
  margin: auto;
  font-weight: 400;
}

.skip {
  display: block;
  margin-top: 10px;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
}
@media (max-width: 768px) {
  h2 {
    font-size: 24px;
    line-height: 28px;
  }
  p {
    font-size: 16px;
    line-height: 25px;
  }
}
</style>
